import React from 'react';
import { ContentWrapper, Header, PopupContent, PopupImage, PopupTextBlock } from '../Popups.styles';
import { createPopup, closePopup } from '../../../services/popupService';
import { ConfirmButton, DismissButton } from '../Popups.styles';
import { oneBtnPopupCreator, ESCALATE_POPUP_CONFIG } from '../ConfirmPopup/helper';
import { emailRegex } from '../../../util';
import { connect } from 'react-redux';
import {
  getEscalationMessage,
  getOutboundEscalationObject,
  extractSelectedTicketFromState,
  getBusinessBlacklistWordsInfoOfSelectedTicket,
  getBusinessBlacklistRegexesInfoOfSelectedTicket,
} from '../../../extractFromState';
import { setEscalationMessage, setOutboundEscalationObject } from '../../../actions/index';
import { validate } from 'email-validator';
import { isLiveChat } from 'util/chat';
import { getMatchingBlacklistedPhrases } from '../../../util/util';
import {
  ValidationErrorMessage,
  EscalateMessageTextArea,
  EmailTextArea,
  StyledSubheading,
} from './EscalateWithEmailPopup.styles';
import { handleError } from 'services/ErrorService/ErrorService';

export default class EscalateWithEmail extends React.Component {
  state = {
    customerEmail: '',
    hasSubmitted: false,
    sendButtonDisabled: false,
    showCustomMessageTextArea: false,
  };

  // if selected ticket is a live chat, disable escalate button only if email is typed

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isSelectedTicketLiveChat) {
      const prevEmail = prevState.customerEmail;
      const currEmail = this.state.customerEmail;

      // if valid email, display textarea
      if (prevEmail !== currEmail) {
        this.setState({
          showCustomMessageTextArea: this.props.isSelectedTicketLiveChat && validate(this.state.customerEmail),
        });
      }

      const prevMessage = prevProps.outboundEscalationObject.outboundEscalationMessage;
      const currMessage = this.props.outboundEscalationObject.outboundEscalationMessage;

      const prevShowCustomMessageTextArea = prevState.showCustomMessageTextArea;
      const currShowCustomMessageTextArea = this.state.showCustomMessageTextArea;

      // check message when typing
      // or enable button if textarea is hidden
      if (prevShowCustomMessageTextArea !== currShowCustomMessageTextArea || prevMessage !== currMessage) {
        if (this.state.showCustomMessageTextArea) {
          this.checkMessageBeforeSending(this.props.outboundEscalationObject.outboundEscalationMessage);
        } else {
          this.setState({ sendButtonDisabled: false });
        }
      }
    }
  }

  // TODO: add email validation
  getValidationError() {
    const trimmedEmailEntry = this.state.customerEmail.trim();
    if (!trimmedEmailEntry) {
      return `Please provide the customer's email, or type "NA" if not available`;
    }
    if (!validate(trimmedEmailEntry) && trimmedEmailEntry.toLowerCase() !== 'na') {
      return `The email you provided is not valid. If no email is available, type "NA"`;
    }
    if (!this.props.escalationReason && !this.props.escalationMessage.trim()) {
      return 'Please provide a reason for escalation';
    }

    return null;
  }

  checkMessageBeforeSending(message) {
    try {
      const blacklistWords = this.props.blacklistWords;
      const blacklistRegexes = this.props.blacklistRegexes;
      const match = getMatchingBlacklistedPhrases(message, blacklistWords, blacklistRegexes);
      this.setState({ sendButtonDisabled: !!match });
    } catch (error) {
      handleError({ error });
      this.setState({ sendButtonDisabled: false });
    }
  }

  render() {
    return (
      <div>
        <ContentWrapper>
          <PopupContent>
            <PopupImage src="/images/green-alert-bell.svg" alt="green-alert-bell" />
            <PopupTextBlock>
              <Header>
                Please add customer's email <br />
                before escalating.
              </Header>
            </PopupTextBlock>
            <PopupTextBlock>
              If you do not have the customer's email <br />
              please cancel, ask the customer for <br />
              their email address, and add it below.
            </PopupTextBlock>
            {this.state.hasSubmitted && this.getValidationError() && (
              <ValidationErrorMessage error={true}>
                <PopupImage src="/images/error-esclamation.svg" alt="error-icon" />
                {this.getValidationError()}
              </ValidationErrorMessage>
            )}
            <EmailTextArea
              autoFocus
              type="text"
              placeholder="Add email"
              value={this.state.customerEmail}
              onChange={({ target: { value } }) => this.setState({ customerEmail: value, hasSubmitted: false })}
            />
            {!this.props.escalationReason && (
              <EscalateMessageTextArea
                type="text"
                placeholder="Reason for escalation..."
                value={this.props.escalationMessage}
                onChange={({ target: { value } }) => {
                  this.props.setEscalationMessage(value);
                  this.setState({ hasSubmitted: false });
                }}
              />
            )}

            {this.props.isSelectedTicketLiveChat && validate(this.state.customerEmail) && (
              <>
                <StyledSubheading>Send message to the customer</StyledSubheading>
                <EscalateMessageTextArea
                  type="text"
                  placeholder="Please explain the escalation reason to the customer."
                  value={
                    this.props.outboundEscalationObject && this.props.outboundEscalationObject.outboundEscalationMessage
                  }
                  onChange={({ target: { value } }) => {
                    this.props.setOutboundEscalationObject({
                      ...this.props.outboundEscalationObject,
                      outboundEscalationMessage: value,
                    });
                    this.setState({ hasSubmitted: false });
                  }}
                />
              </>
            )}
          </PopupContent>
        </ContentWrapper>
        <DismissButton
          onClick={() => {
            closePopup();
          }}
        >
          DISMISS
        </DismissButton>
        <ConfirmButton
          disabled={this.state.sendButtonDisabled}
          onClick={() => {
            this.setState({ hasSubmitted: true });
            if (!this.getValidationError()) {
              closePopup();
              this.props
                .onEscalate({
                  escalateMessage: this.props.escalationReason || this.props.escalationMessage,
                  customerEmail: emailRegex.test(this.state.customerEmail.trim())
                    ? this.state.customerEmail.trim()
                    : undefined,
                })
                .then(() => oneBtnPopupCreator(ESCALATE_POPUP_CONFIG.escalateConfirmConfig));
            }
          }}
        >
          ESCALATE NOW
        </ConfirmButton>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  escalationMessage: getEscalationMessage(state),
  outboundEscalationObject: getOutboundEscalationObject(state),
  isSelectedTicketLiveChat:
    !!extractSelectedTicketFromState(state) && isLiveChat(extractSelectedTicketFromState(state).communicationType),
  blacklistWords: getBusinessBlacklistWordsInfoOfSelectedTicket(state),
  blacklistRegexes: getBusinessBlacklistRegexesInfoOfSelectedTicket(state),
});

const mapDispatchToProps = (dispatch) => ({
  setEscalationMessage(escalationMessage) {
    dispatch(setEscalationMessage(escalationMessage));
  },
  setOutboundEscalationObject(message) {
    dispatch(setOutboundEscalationObject(message));
  },
});

const EscalateWithEmailContainer = connect(mapStateToProps, mapDispatchToProps)(EscalateWithEmail);

export const openEscalationWithEmailPopup = (escalationReason, onEscalate) =>
  createPopup({
    type: 'EscalateWithEmail',
    title: null,
    content: <EscalateWithEmailContainer onEscalate={onEscalate} escalationReason={escalationReason} />,
    noOverlay: false,
    closeOnOutsideClick: false,
  });
